import { BoxTheme } from '@/components/Box/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Box = GenericSlot({ as: 'div', theme: BoxTheme });
